import { useEffect } from "react";
import { Container, Row } from "reactstrap";
import { Chats, PrivateChat } from "../../../../constants";
import { useAppDispatch } from "../../../../reduxToolkit/hooks";
import { fetchChatApiData, fetchChatMemberApiData } from "../../../../reduxToolkit/reducers/chatSlice";
import Sidebar from "../common/sideBar";
import ChatWindow from "../common/chatWindow";
import Breadcrumbs from "../../../../coreComponents/breadcrumbs";

// This component handles the layout and data fetching for private chats.
const PrivateContainer = () => {
  const dispatch = useAppDispatch();
  useEffect(() => {
    dispatch(fetchChatMemberApiData());
    dispatch(fetchChatApiData());
  }, [dispatch]);

  return (
    <>
      <Breadcrumbs mainTitle={PrivateChat} parent={Chats} />
      <Container fluid>
        <Row className="g-0">
          <Sidebar />
          <ChatWindow />
        </Row>
      </Container>
    </>
  );
};

export default PrivateContainer;
